import { render } from "./RedoIcon.vue?vue&type=template&id=046754f3"
import script from "./RedoIcon.vue?vue&type=script&lang=js"
export * from "./RedoIcon.vue?vue&type=script&lang=js"
script.render = render

export default script